export var MediaTrackRole;
(function (MediaTrackRole) {
    MediaTrackRole["MAIN"] = "MAIN";
    MediaTrackRole["CAPTION"] = "CAPTION";
    MediaTrackRole["ALTERNATE"] = "ALTERNATE";
    MediaTrackRole["TRANSCRIBES_SPOKEN_DIALOG"] = "TRANSCRIBES_SPOKEN_DIALOG";
    MediaTrackRole["DESCRIBES_MUSIC_AND_SOUND"] = "DESCRIBES_MUSIC_AND_SOUND";
    MediaTrackRole["FORCED"] = "FORCED";
})(MediaTrackRole || (MediaTrackRole = {}));
export var CastMediaTrackType;
(function (CastMediaTrackType) {
    CastMediaTrackType["AUDIO"] = "1";
    CastMediaTrackType["TEXT"] = "3";
})(CastMediaTrackType || (CastMediaTrackType = {}));
